import ApiService from "../apiservice";

class EmpresasRecuperacaoJudicialService extends ApiService {

    constructor() {
        super('/api/empresas');
    }

    listarEmpresasEmRecuperacaoJudicial(credenciais) {
        return this.post('/buscarEmprepresasRecupJudicial', credenciais)
    }

    gerarRelatorioEmRecuperacaoJudicial(credenciais) {
        return this.get('/relatorioEmpresasRecupJudicial', credenciais)
    }

  
}

export default EmpresasRecuperacaoJudicialService;